import { inject, Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Factory } from '../factory';
import {
  DEFAULT_LICENSES,
  ELicenseChannelState,
  ILicense,
  LicenseId,
  LicenseKey,
} from '@web/dtos';
import {
  ILicenseForm,
  ILicenseFormDataWrapper,
  ILicenseFormWrapper,
} from '../../entities/license-entity';

@Injectable({
  providedIn: 'root',
})
export class LicenseFormsFactoryService extends Factory<
  ILicenseFormWrapper,
  ILicense[]
> {
  formBuilder: FormBuilder = inject(FormBuilder);

  buildForm(
    entity: ILicense[] = DEFAULT_LICENSES
  ): FormGroup<ILicenseFormWrapper> {
    return this.formBuilder.group<ILicenseFormWrapper>({
      licenses: this.formBuilder.array<FormGroup<ILicenseForm>>(
        entity.map((license: ILicense): FormGroup<ILicenseForm> => {
          return this.buildLicenseFormGroup(license);
        })
      ),
    });
  }

  buildLicenseFormGroup(license: ILicense): FormGroup<ILicenseForm> {
    return this.formBuilder.group<ILicenseForm>({
      id: this.formBuilder.control<LicenseId | null>(license?.id || null),
      key: this.formBuilder.nonNullable.control<LicenseKey>(license?.key, [
        Validators.required,
      ]),
      label: this.formBuilder.nonNullable.control<string>(license?.label, [
        Validators.required,
      ]),
      description: this.formBuilder.nonNullable.control<string>(
        license?.description,
        [Validators.required]
      ),
      icon: this.formBuilder.nonNullable.control<string>(license?.icon, [
        Validators.required,
      ]),
      position: this.formBuilder.nonNullable.control<number>(
        license?.position,
        [Validators.required]
      ),
      webState: this.formBuilder.nonNullable.control<ELicenseChannelState>(
        license?.webState,
        [Validators.required]
      ),
      appState: this.formBuilder.nonNullable.control<ELicenseChannelState>(
        license?.appState,
        [Validators.required]
      ),
    });
  }

  buildEntity(forms: FormGroup<ILicenseFormWrapper>): ILicense[] {
    const wrapper = forms.getRawValue() as ILicenseFormDataWrapper;

    const newLicenses: ILicense[] = [];
    wrapper.licenses.forEach((license: ILicense) => {
      const newLicense: ILicense = {
        ...license,
      };
      this.removeNullIds(newLicense);
      newLicenses.push(newLicense);
    });
    return newLicenses as ILicense[];
  }
}
